export default __webpack_public_path__ + "static/media/Background_00147.3eeef17e.png";